import DetailedTermSelector from 'pricing-pages-ui/components/common/DetailedTermSelector';
import Whitespace from 'pricing-pages-ui/components/common/Whitespace';
import { commonAvailableTermsSelector, crmSuiteAvailableTermsSelector } from 'pricing-pages-ui/selectors/OfferSelectors';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useAppSelector } from '../../reducers';
import { currentSuiteSkuIdsForProductLevelSelector, getIsTBSkuSelector } from '../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTermSelectorContainer = styled(DetailedTermSelector).withConfig({
  displayName: "SuiteTermSelectorContainer__StyledTermSelectorContainer",
  componentId: "sc-178heh8-0"
})(["margin:0 auto;"]);
const SuiteTermSelectorContainer = ({
  queryParamTerm,
  productLevel,
  onChange,
  trackingSource
}) => {
  const skuIds = useSelector(reduxState => {
    return currentSuiteSkuIdsForProductLevelSelector(reduxState, {
      productLevel
    });
  });
  const isSuiteBundle = useAppSelector(state => {
    return skuIds && skuIds.length === 1 && getIsTBSkuSelector(state, {
      skuId: skuIds[0]
    });
  });
  const hasMultipleTerms = useSelector(reduxState => isSuiteBundle ? commonAvailableTermsSelector(reduxState, {
    skuIds
  }) : crmSuiteAvailableTermsSelector(reduxState, {
    productLevel
  })).length > 1;
  if (!hasMultipleTerms) {
    return /*#__PURE__*/_jsx(Whitespace, {
      height: 41
    });
  }
  const trackingSourceString = `${trackingSource}-${productLevel.toLowerCase()}`;
  return /*#__PURE__*/_jsx(StyledTermSelectorContainer, {
    skuIds: skuIds,
    onChange: onChange,
    trackingSource: trackingSourceString,
    activeTerm: queryParamTerm,
    screen: NavItemEnum.SUITE
  });
};
export default SuiteTermSelectorContainer;